import {
  ControlCode,
  InboxesParams,
  service,
  useAuthConfig,
} from "@theprelude/core";
import { Button, DownloadIcon, IconButton } from "@theprelude/ds";
import { useDownloadJobFile } from "@/hooks/use-download-job-file";
import { getControlSlug } from "@/queries/control-monitor";
import { DefaultTooltip } from "../default-tooltip";

type ExportInboxesProps = {
  control?: ControlCode;
  query?: InboxesParams["query"];
};

const useDownload = ({ control, query }: ExportInboxesProps) => {
  const authConfig = useAuthConfig();

  const getJobId = () =>
    service(authConfig)
      .export.downloadInboxesCsv({ query })
      .then(({ job_id }) => job_id);

  const filename =
    control === undefined
      ? "inboxes.csv"
      : `inboxes_${getControlSlug(control)}.csv`;

  return useDownloadJobFile({ getJobId, filename });
};

export const ExportInboxesIconButton: React.FC<ExportInboxesProps> = (
  props,
) => {
  const { download, isDownloading } = useDownload(props);

  return (
    <DefaultTooltip asChild content="Export inboxes">
      <IconButton
        icon={<DownloadIcon className="size-4 text-secondary-foreground" />}
        disabled={isDownloading}
        loading={isDownloading}
        onClick={() => download()}
        className="flex h-9 w-10 items-center justify-center border border-stroke-line"
      />
    </DefaultTooltip>
  );
};

export const ExportInboxesButton: React.FC<ExportInboxesProps> = (props) => {
  const { download, isDownloading } = useDownload(props);

  return (
    <Button
      intent="pill"
      size="tiny"
      icon={<DownloadIcon className="size-4 text-secondary-foreground" />}
      disabled={isDownloading}
      loading={isDownloading}
      onClick={() => download()}
    >
      Export inboxes
    </Button>
  );
};
